export type ApiErrorKind =
  | 'validation'
  | 'unauthorized'
  | 'forbidden'
  | 'not-found'
  | 'conflict'
  | 'server'
  | 'network'
  | 'timeout'
  | 'cancelled'
  | 'parsing'
  | 'unknown'

export class ApiError extends Error {
  constructor(
    public readonly kind: ApiErrorKind,
    message: string,
    public readonly status?: number,
    public readonly fieldErrors: Readonly<Record<string, readonly string[]>> = {},
    public readonly cause?: unknown,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

export function isApiError(value: unknown): value is ApiError {
  return value instanceof ApiError
}
